import { FC } from 'react';
import cn from 'classnames';

import styles from './DropdownItem.module.scss';
import { IDropdownItemProps } from '../interfaces/IDropdownItemProps';

export const DropdownItem: FC<IDropdownItemProps> = ({
  onClick,
  isDisabled,
  isDanger,
  isSuccess,
  children,
  format,
  id,
}) => {
  return (
    <button
      type="button"
      onClick={isDisabled ? undefined : onClick}
      className={cn(styles.MenuButton, {
        [styles.MenuButtonSuccess]: isSuccess,
        [styles.MenuButtonDanger]: isDanger,
        [styles.MenuButtonDisabled]: isDisabled,
      })}
      disabled={isDisabled}
      {...(format !== undefined ? { 'data-format': format } : {})}
      id={id}
    >
      {children}
    </button>
  );
};
